import { render, staticRenderFns } from "./school-card.vue?vue&type=template&id=44aec866"
import script from "./school-card.vue?vue&type=script&lang=js"
export * from "./school-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports